
// import './assets/Table.css'
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { 
    setShowVehicle,
    setSelectedVehicle,
} from './redux/vehicleSlice.js'

import { useAuth0 } from "@auth0/auth0-react";
import classNames from "classnames";
import apiClient from './services/apiClient.js';


const VehicleListV2 = ({client}) => {

    const dispatch = useDispatch()
    const isAutoScan = useSelector((state) => state.autoScan.isAutoScan);
    const vehicleListDivRef = React.useRef(null);
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [isLoadingVehicles, _setIsLoadingVehicles] = useState(true);
    
    const isLoadingVehiclesRef = React.useRef(isLoadingVehicles);

    const [vehicles, _setVehicles] = useState([]);
    const vehiclesStateRef = React.useRef([]);
    const setVehicles = data => {
            vehiclesStateRef.current = data;
            _setVehicles(data);
    };

    // const [vehicleHistoryCounts, setVehicleHistoryCounts] = useState({});

    // Audio alert for all vehicles
    const playVehicleDetectionAlert = async () => {
        console.log('🔔 playVehicleDetectionAlert() called');
        
        // Check if sound is enabled in settings
        const soundEnabled = localStorage.getItem('allVehicleSoundEnabled');
        console.log('🔔 allVehicleSoundEnabled from localStorage:', soundEnabled);
        
        if (soundEnabled !== null && !JSON.parse(soundEnabled)) {
            console.log('🔇 All vehicle alert sound is disabled in settings');
            return; // Silently return if disabled
        }
        
        console.log('🔊 Playing all vehicle detection beep...');
        
        try {
            // Create an audio context and play a short, gentle beep
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            
            // Resume audio context if suspended (required for some browsers)
            if (audioContext.state === 'suspended') {
                console.log('🔊 AudioContext suspended, attempting to resume...');
                await audioContext.resume();
            }
            
            console.log('🔊 AudioContext state:', audioContext.state);
            
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            
            oscillator.frequency.value = 800; // Gentle mid-tone
            oscillator.type = 'sine';
            
            gainNode.gain.setValueAtTime(0.2, audioContext.currentTime); // Quieter than drive-off alert
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);
            
            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.1); // Very short beep (100ms)
            
            console.log('✅ All vehicle detection beep played successfully');
        } catch (error) {
            console.error('❌ Error playing all vehicle detection beep:', error);
        }
    };

    // Audio alert for drive-off detection
    const playDriveOffAlert = async () => {
        // Check if sound is enabled in settings
        const soundEnabled = localStorage.getItem('driveOffSoundEnabled');
        if (soundEnabled !== null && !JSON.parse(soundEnabled)) {
            console.log('🔇 Drive-off alert sound is disabled in settings');
            return;
        }
        
        try {
            // Create an audio context and play a distinctive alert sound
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            
            // Resume audio context if suspended (required for some browsers)
            if (audioContext.state === 'suspended') {
                console.log('🔊 AudioContext suspended, attempting to resume...');
                await audioContext.resume();
            }
            
            console.log('🔊 AudioContext state:', audioContext.state);
            
            // Play three beeps with increasing urgency
            const playBeep = (frequency, startTime, duration) => {
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();
                
                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);
                
                oscillator.frequency.value = frequency;
                oscillator.type = 'sine';
                
                gainNode.gain.setValueAtTime(0.3, audioContext.currentTime + startTime);
                gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + startTime + duration);
                
                oscillator.start(audioContext.currentTime + startTime);
                oscillator.stop(audioContext.currentTime + startTime + duration);
            };
            
            // Three urgent beeps: high-low-high pattern
            playBeep(1000, 0, 0.15);    // First beep
            playBeep(800, 0.2, 0.15);   // Second beep (lower)
            playBeep(1000, 0.4, 0.3);   // Third beep (longer, urgent)
            
            console.log('✅ Drive-off alert sound played');
        } catch (error) {
            console.error('❌ Error playing drive-off alert:', error);
        }
    };

    const setIsLoadingVehicles = data => {
        isLoadingVehiclesRef.current = data;
        _setIsLoadingVehicles(data);
    };

    const getSelectedVehicleForPlateAsync = async (vehicle) => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }
        
            const accessToken = await getAccessTokenSilently({
                authorizationParams: {
                      audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
                  }
              });
              const userRole = user['/roles'][0];
                const isLoadingRefState = isLoadingVehiclesRef.current;
                if(!isLoadingRefState) {
                    setIsLoadingVehicles(true);
                    const groupName = userRole;
                    const params = {
                        groupName,
                        plate: vehicle.plate,
                        dateTimeUtc: vehicle.dateTimeUtc
                    };
            
                    const result = await apiClient.getSelectedVehicleForPlateAsync(params, accessToken)
                    setIsLoadingVehicles(false);
                    dispatch(setShowVehicle(true));
                    dispatch(setSelectedVehicle(result));
                }
    }

    const handleOnVehicleSelected = (vehicle) => {

        getSelectedVehicleForPlateAsync(vehicle)

        // dispatch(setShowVehicle(true));
        // dispatch(setSelectedVehicle(vehicle));
    }



const loadVehiclesForGroupAsync = async (pageNumber) => {

    if (!isAuthenticated || user['/roles'].length === 0) {
        return;
     }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                  audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
              }
          });
          const userRole = user['/roles'][0];
        const batchSize = process.env.REACT_APP_VEHICLE_LIST_BATCH_SIZE;
        const params = {
            groupName: userRole,
            pageNumber,
            batchSize
        };

        const result = await apiClient.getVehiclesForGroupAsync(params, accessToken)
        if(pageNumber === 1)
        {
            // console.log(`📋 Loaded ${result.length} vehicles on initial fetch`);
            
            // Debug: Log all vehicles with their isDriveOff status
            // result.forEach((vehicle, index) => {
            //     console.log(`Vehicle ${index + 1}: ${vehicle.plate} - isDriveOff: ${vehicle.isDriveOff}`);
            // });
            
            // Check if any of the loaded vehicles have unpaid drive-offs
            const driveOffVehicles = result.filter(vehicle => vehicle.isActiveDriveOff);
            // console.log(`🔍 Found ${driveOffVehicles.length} vehicles with isDriveOff === true`);
            
            if (driveOffVehicles.length > 0) {
                // console.log(`🚨 ALERT: ${driveOffVehicles.length} vehicle(s) with unpaid drive-offs detected!`);
                // driveOffVehicles.forEach(vehicle => {
                //     console.log(`   - ${vehicle.plate} (detected at ${vehicle.dateTimeUtc})`);
                // });
                // Play alert sound
                // console.log('🔊 Playing drive-off alert sound...');
                playDriveOffAlert();
            } else {
                // console.log('✅ No drive-off vehicles found in initial load');
            }
            
            setVehicles(result)
            setIsLoadingVehicles(false);
            // console.log(`Initial Fetch done - ${componentAlertStatus}`);
            return;
        }
        const vehiclesState = vehiclesStateRef.current;
        //Add to the end as this is paging sorted by date descending. 
        setVehicles([...vehiclesState, ...result]);
        setIsLoadingVehicles(false);
}

const isAtBottomOfPage = (threshold = 100) => {
    return window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold;
}

const trackScrolling = () => {
    if (!isAtBottomOfPage(100)) {
        return;
    }
    const batchSize = process.env.REACT_APP_VEHICLE_LIST_BATCH_SIZE;
    const vehiclesState = vehiclesStateRef.current;
    if (vehiclesState.length === 0) return;
    const isLoadingVehiclesState = isLoadingVehiclesRef.current;
    // Only load if not already loading and last batch was full
    if (!isLoadingVehiclesState && vehiclesState.length % batchSize === 0) {
        setIsLoadingVehicles(true);
        const vehiclesListPageNo = vehiclesState.length / batchSize;
        loadVehiclesForGroupAsync(vehiclesListPageNo + 1);
    }
}

useEffect(() => {
    // Add scroll listener to window for infinite scroll
    window.addEventListener('scroll', trackScrolling, { passive: true });
    // Load first page of the list
    loadVehiclesForGroupAsync(1);
    // Subscribed to pubsub group messages
    client.on("group-message", (e) => {
        const message = e.message.data;
        const alertStatus = message.alertStatus;
        // console.log(alertStatus)
    
        // if(componentAlertStatus === alertStatus) {
          const vehiclesState = vehiclesStateRef.current;
          
          // Check for duplicates before adding new vehicle
          const isDuplicate = vehiclesState.some(existingVehicle => 
            existingVehicle.plate === message.plate && 
            existingVehicle.dateTimeUtc === message.dateTimeUtc
          );
          
          if (!isDuplicate) {
            // console.log(`🚗 New vehicle detected: ${message.plate}, isDriveOff: ${message.isDriveOff}`);
            
            // Play audio alerts
            if (message.isActiveDriveOff) {
              // Urgent drive-off alert
              // console.log(`🚨 DRIVE-OFF ALERT: Vehicle ${message.plate} detected!`);
              playDriveOffAlert();
            } else {
              // Gentle beep for all vehicles (if enabled)
              // console.log(`🔔 Regular vehicle detected, calling playVehicleDetectionAlert()...`);
              playVehicleDetectionAlert();
            }
            
          setVehicles([...[e.message.data], ...vehiclesState]);
          } else {
            // console.log(`Duplicate vehicle detection ignored: ${message.plate} at ${message.dateTimeUtc}`);
          }
        //   return;
        // }

        // ...existing code...
    });
    return () => {
        window.removeEventListener("scroll", trackScrolling);
        vehiclesStateRef.current?.close && vehiclesStateRef.current.close();
        vehiclesStateRef.current = null;
    };
}, []);

const getTimeOnly = (vehicle) => {
    const locale = (navigator && navigator.language) || "en"
    const timeOnly = vehicle.dateTimeUtc ? new Date(vehicle.dateTimeUtc).toLocaleString(locale, {
        timeStyle: "short"
    }) : null 
    return timeOnly;
}

const formatPlate = (plate) => {
    if (!plate || plate === 'unknown') return plate;
    // Add dash after 3rd character if plate is exactly 6 characters
    if (plate.length === 6) {
        return `${plate.substring(0, 3)}-${plate.substring(3)}`;
    }
    return plate;
}

const getVehicleImageUrl = (vehicle) => {
    if (vehicle.vehicleImageUrl && vehicle.vehicleImageUrl.length !== 0)
        return vehicle.vehicleImageUrl;

    if (vehicle.regoPlateImageUrl && vehicle.regoPlateImageUrl.length !== 0)
        return vehicle.regoPlateImageUrl;
}

const vehicleCards = vehicles.map((vehicle, index) => {
    const isVehicleNotFound = isAutoScan && vehicle.message === "NOT FOUND";
    const carAutoScanInfoAvailable = isAutoScan && vehicle.registeredMake && vehicle.registeredMake !== "NA";
    const vehicleImageUrl = getVehicleImageUrl(vehicle);
    const historyCount = vehicle.historyCount;
    
    // Log all available vehicle data to console
    // console.log(`Vehicle ${index + 1} - ${vehicle.plate || 'Unknown Plate'}:`, {
    //     ...vehicle,
    //     allKeys: Object.keys(vehicle),
    //     totalProperties: Object.keys(vehicle).length,
    //     historyCount: historyCount
    // });
    
    // Status colors - prioritize drive-offs
    const getStatusColor = () => {
        if (vehicle.alertStatus === 'Red') 
            return 'border-danger'; // RED border for unpaid drive-offs

        if (carAutoScanInfoAvailable) 
            return 'border-warning';

        return 'border-secondary';
    };

    const alertStatusClassNames = classNames({
        'red-alert-status': vehicle.alertStatus === 'Red',
        'green-alert-status': vehicle.alertStatus === 'Green',
        'amber-alert-status': vehicle.alertStatus === 'Amber',
        'neutral-alert-status': vehicle.alertStatus === 'Neutral'
    })
    

    return (
        <div key={`vehicle-${vehicle.plate}-${index}`} className="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <div 
                className={`card h-100 ${getStatusColor()} ${vehicle.isActiveDriveOff ? 'drive-off-alert' : ''}`}
                style={{
                    borderRadius: '16px',
                    borderWidth: vehicle.isActiveDriveOff ? '3px' : '1px',
                    borderColor: vehicle.isActiveDriveOff ? '#dc3545' : '#e9ecef',
                    boxShadow: vehicle.isActiveDriveOff ? '0 4px 20px rgba(220, 53, 69, 0.3)' : '0 2px 12px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease', 
                    cursor: 'pointer',
                    overflow: 'hidden'
                }} 
                onClick={() => handleOnVehicleSelected(vehicle)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = vehicle.isActiveDriveOff ? '0 8px 30px rgba(220, 53, 69, 0.4)' : '0 8px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = vehicle.isActiveDriveOff ? '0 4px 20px rgba(220, 53, 69, 0.3)' : '0 2px 12px rgba(0,0,0,0.08)';
                }}
            >
                {/* Vehicle Image */}
                <div className="position-relative" style={{height: '180px', overflow: 'hidden'}}>
                    <img 
                        src={vehicleImageUrl} 
                        alt={vehicle.plate}
                        className="card-img-top h-100 w-100"
                        style={{objectFit: 'cover'}}
                    />
                    
                    {/* Status Badge */}
                    {(vehicle.isVehicleStolen || isVehicleNotFound) && (
                        <div className="position-absolute top-0 start-0 m-2">
                            <span className="badge px-3 py-2" style={{
                                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                fontSize: '12px',
                                fontWeight: '600',
                                borderRadius: '50px',
                                boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="fa fa-shield-exclamation"></i>
                                {vehicle.isVehicleStolen ? 'STOLEN' : 'NOT FOUND'}
                            </span>
                        </div>
                    )}
                    
                    {/* Plate Image Overlay */}
                    {vehicle.regoPlateImageUrl && vehicle.regoPlateImageUrl.length !== 0 && (
                        <div className="position-absolute top-0 end-0 m-2" style={{width: '70px', height: '35px'}}>
                            <img 
                                src={vehicle.regoPlateImageUrl} 
                                alt={`Plate ${vehicle.plate}`}
                                className="img-fluid h-100 w-100"
                                style={{objectFit: 'cover', border: '2px solid white', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)'}}
                            />
                        </div>
                    )}
                    
                    {/* Drive-Off Alert Badge */}
                    {vehicle.isActiveDriveOff && (
                        <div className="position-absolute bottom-0 start-0 end-0 m-0 px-3 py-2" 
                             style={{
                                 background: 'linear-gradient(to top, rgba(220,38,38,0.98), rgba(220,38,38,0.85))',
                                 backdropFilter: 'blur(8px)'
                             }}>
                            <div className="d-flex align-items-center justify-content-center gap-2 text-white fw-bold" style={{fontSize: '13px'}}>
                                <i className="fa fa-shield-exclamation"></i>
                                UNPAID DRIVE-OFF
                            </div>
                        </div>
                    )}
                    
                    {/* Hover Overlay */}
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
                         style={{backgroundColor: 'rgba(30, 112, 224, 0.15)', opacity: 0, transition: 'opacity 0.3s ease', backdropFilter: 'blur(2px)'}}
                         onMouseEnter={(e) => e.target.style.opacity = '1'}
                         onMouseLeave={(e) => e.target.style.opacity = '0'}>
                        <span className="px-4 py-2 fw-bold" style={{
                            background: 'linear-gradient(135deg, #1E70E0 0%, #0D47A1 100%)',
                            color: 'white',
                            borderRadius: '50px',
                            fontSize: '13px',
                            boxShadow: '0 4px 12px rgba(30, 112, 224, 0.4)'
                        }}>
                            <i className="fa fa-eye me-2"></i>
                            View Details
                        </span>
                    </div>
                </div>
                
                {/* Text Area - Responsive Layout */}
                <div 
                    className={`card-body d-flex align-items-center justify-content-center p-3 ${alertStatusClassNames}`} 
                    style={{
                        minHeight: '44px',
                        color: 'white'
                    }}
                >
                    <div className="text-center w-100">
                        {/* Desktop View: Show all info */}
                        <span 
                            className="d-none d-md-flex"
                            style={{
                                fontWeight: vehicle.plate === 'unknown' ? '500' : (historyCount >= 5 ? '600' : '500'),
                                color: 'white',
                                fontSize: '16px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                        >
                            <span>{getTimeOnly(vehicle)}</span>
                            <span>•</span>
                            <span className="fw-bold">{formatPlate(vehicle.plate)}</span>
                            {vehicle.plate !== 'unknown' && (
                                <>
                                    <span>•</span>
                                    <span>
                                        {historyCount} visit{historyCount !== 1 ? 's' : ''}
                                    </span>
                                </>
                            )}
                        </span>
                        
                        {/* Mobile View: Show only visit count */}
                        <div className="d-md-none">
                            {vehicle.plate !== 'unknown' && (
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <span style={{fontSize: '23px', fontWeight: '700'}}>
                                        {historyCount} visit{historyCount !== 1 ? 's' : ''}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});


const loadingSpinner = isLoadingVehicles ? 
(
    <div className="d-flex justify-content-center align-items-center py-4">
        <div className="text-center">
            <div className="spinner-border text-primary mb-2" role="status" style={{color: '#1E70E0'}}>
                <span className="visually-hidden">Loading vehicles...</span>
            </div>
            <p className="text-muted mb-0">Loading vehicle data...</p>
        </div>
    </div>
): null;

   return (
        <div className="row g-1" ref={vehicleListDivRef}>
                    {vehicleCards}
                    {loadingSpinner}
                </div>
    );
}

export default VehicleListV2;
 